<template>
  <div class="main-box mh-a">
    <div
      class="h140px ovh lh140 fs30 c-white text-center solution-title"
      :style="`background-image: url(${solutionDetial.showImg});`"
    >
      {{ solutionDetial.title }}
    </div>
    <ul
      class="w-total factory-box flex mv20 c-g-d border-gray lh45 text-center"
    >
      <li
        v-for="(item, index) in solutionDetial.infoData"
        :class="{ 'tab-hover': indexVal === index }"
        :key="`${index}_factory`"
        @click="solutionItem(index)"
      >
        {{ item.title }}
      </li>
    </ul>
    <div class="m-fa">
      <h3>方案概述</h3>
      <p class="fs14 c-g-d p20 lh24 text-indent">
        {{ solutionDetial.infoData[indexVal].introduce }}
      </p>
      <div v-if="solutionDetial.infoData[indexVal].introduceImg">
        <div
          v-for="(int, inx) in solutionDetial.infoData[indexVal].introduceImg"
          :key="`${inx}_int`"
        >
          <div v-if="int.type === 'row'" class="p20 fs14 lh30">
            <el-image
              class="w-total"
              :src="`./static/img/solution/6/${int.url}`"
              fit="cover"
            ></el-image>
            <h4 class="fs14 lh30 c-g-d text-center">
              {{ int.name }}
            </h4>
            <div v-if="int.info">
              <p
                v-for="(infoItem, x) in int.info"
                :key="x + '_infoItem'"
                class="text-indent"
              >
                <span class="fw-s">{{ infoItem.label }}</span>
                <span>{{ infoItem.val }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <h3 v-if="solutionDetial.infoData[indexVal].label != ''">方案优势</h3>
      <ol class="p20 fs14 c-g-d">
        <li
          v-for="(text, dex) in solutionDetial.infoData[indexVal].label"
          :key="`${dex}_label`"
          class="m5"
        >
          <p class="fw-s pv10">
            <span class="rect d-i mr10"></span>{{ text.name }}
          </p>
          <p class="pl20 lh20">
            {{ text.val }}
          </p>
        </li>
      </ol>
      <h3>{{ indexVal === 1 ? "产品参数" : "应用领域" }}</h3>
      <p
        class="fs14 c-g-d p20 lh24 text-indent"
        v-if="solutionDetial.infoData[indexVal].field"
      >
        {{ solutionDetial.infoData[indexVal].field }}
      </p>
      <div
        v-for="(rowItem, index) in solutionDetial.infoData[indexVal].img"
        :key="`${index}_ftxs`"
      >
        <div v-if="rowItem.type === 'row'" class="p20 fs14 lh30">
          <el-image
            class="w-total"
            :src="`./static/img/solution/6/${rowItem.url}`"
            fit="cover"
          ></el-image>
          <h4 class="fs14 lh30 c-g-d text-center">
            {{ rowItem.name }}
          </h4>
          <div v-if="rowItem.info">
            <p
              v-for="(infoItem, x) in rowItem.info"
              :key="x + '_infoItem'"
              class="text-indent"
            >
              <span class="fw-s">{{ infoItem.label }}</span>
              <span>{{ infoItem.val }}</span>
            </p>
          </div>
        </div>
      </div>
      <el-row :gutter="20" type="flex" justify="space-around">
        <el-col
          :xs="24"
          :sm="6"
          v-for="(item, index) in list"
          :key="`${index}_fx`"
          class="text-center"
        >
          <div :class="item.size ? `ph${item.size}` : 'ph60'" class="pv40 m-ly">
            <el-image
              class="w-total"
              :src="`./static/img/solution/6/${item.url}`"
              fit="cover"
            ></el-image>
            <h4 class="fs14 lh30 c-g-d">{{ item.name }}</h4>
          </div>
        </el-col>
      </el-row>
      <div
        v-for="(row, i) in solutionDetial.infoData[indexVal].scene"
        :key="`${i}_scene`"
      >
        <div v-if="row.type === 'row'" class="p20 fs14 lh30">
          <el-image
            class="w-total"
            :src="`./static/img/solution/6/${row.url}`"
            fit="cover"
          ></el-image>
          <h4 class="text-center">{{ row.name }}</h4>
          <div v-if="row.info">
            <p
              v-for="(rowInfo, ix) in row.info"
              :key="ix + '_infoItem'"
              class="text-indent"
            >
              <span class="fw-s">{{ rowInfo.label }}</span>
              <span>{{ rowInfo.val }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <sales-hotline></sales-hotline>
  </div>
</template>

<script>
import SalesHotline from "@/components/SalesHotline";
import solutionList from "@/assets/solution/solutionList";
import solutionListEn from "@/assets/solution/solutionList-en";
export default {
  name: "SmartFactory",
  data() {
    return {
      indexVal: 0,
    };
  },
  methods: {
    solutionItem(x) {
      this.indexVal = x;
    },
  },
  computed: {
    solutionDetial() {
      let list =
        this.$store.state.language === "zh" ? solutionList : solutionListEn;
      return list[5];
    },
    list() {
      return this.solutionDetial.infoData[this.indexVal].img.filter((item) => {
        return item.type !== "row";
      });
    },
  },
  components: {
    SalesHotline,
  },
};
</script>

<style lang="less" scoped>
</style>